import Home from "./pages/Home";
import {
  BrowserRouter, Routes, Route, Navigate
} from "react-router-dom";
import Reservation from "./pages/Reservation";
import CMSPage from "./pages/CMSPage";
import MyReservation from "./pages/MyReservation";
import ThankYouPage from "./pages/ThankYouPage";
import PaymentCancelPage from "./pages/PaymentCancelPage";
import SearchBookingPage from "./pages/SearchBookingPage";
import ReservationListAccess from "./pages/ReservationListAccess";
import AI from "./pages/AI";
import DriverLogin from "./features/driver/pages/DriverLogin";
import DriverDashboard from "./features/driver/pages/DriverDashboard";
import DriverOrderDetail from "./features/driver/pages/DriverOrderDetail";
import DeliveryFeedback from "./features/delivery/pages/DeliveryFeedback";
import Clarity from '@microsoft/clarity';
import ReactGA from "react-ga4";
import GoogleAnalytics from "./components/GoogleAnalytics";
import { Toaster } from "@/components/ui/toaster";
import { getRegionConfig } from "./lib/regionConfig";

function App() {
  const regionConfig = getRegionConfig();

  // Initialize Clarity for all environments
  Clarity.init(regionConfig.clarityId);

  // Initialize GA for both production and staging
  const isProduction = import.meta.env.VITE_BUILD_ENV === 'production';
  const isStaging = import.meta.env.VITE_BUILD_ENV === 'staging';
  const isDebugMode = import.meta.env.VITE_GA_DEBUG === 'true';

  // Get GA4 Measurement ID from region config
  const GA4_MEASUREMENT_ID = regionConfig.ga4MeasurementId;
  
  // Initialize GA for both production and staging environments
  if (isProduction || isStaging) {
    // Enable debug mode if explicitly set
    if (isDebugMode) {
      window.localStorage.setItem('debug', '*');
      // Enable GA debug mode
      window.gtag?.('config', GA4_MEASUREMENT_ID, {
        debug_mode: true
      });
    }

    ReactGA.initialize(GA4_MEASUREMENT_ID, {
      testMode: isStaging,
      gaOptions: {
        debug_mode: isDebugMode
      },
      gtagOptions: {
        debug_mode: isDebugMode
      }
    });
    
    // Log initialization
    console.log('GA4 initialized in', import.meta.env.VITE_BUILD_ENV, 'environment with:', {
      measurementId: GA4_MEASUREMENT_ID,
      debugMode: isDebugMode,
      testMode: isStaging
    });
  }

  // Multiple products (previously known as trackers)
// ReactGA.initialize([
  //   {
  //     trackingId: "your GA measurement id",
  //     gaOptions: {...}, // optional
  //     gtagOptions: {...}, // optional
  //   },
  //   {
  //     trackingId: "your second GA measurement id",
  //   },
  // ]);

  // // Send pageview with a custom path
  // ReactGA.send({ hitType: "pageview", page: "/my-path", title: "Custom Title" });

  // // Send a custom event
  // ReactGA.event({
  //   category: "your category",
  //   action: "your action",
  //   label: "your label", // optional
  //   value: 99, // optional, must be a number
  //   nonInteraction: true, // optional, true/false
  //   transport: "xhr", // optional, beacon/xhr/image
  // });
  return <BrowserRouter>
    <GoogleAnalytics measurementId={GA4_MEASUREMENT_ID} />
    <Toaster />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="reservation" element={<Reservation />} />
      <Route path="pages/:slug" element={<CMSPage />} />
      <Route path="my-reservation/:slug" element={<MyReservation />} />
      <Route path="thank-you" element={<ThankYouPage />} />
      <Route path="payment-cancellation" element={<PaymentCancelPage />} />
      <Route path="search-booking" element={<SearchBookingPage />} />
      <Route path="reservations-list/access/:slug" element={<ReservationListAccess />} />
      <Route path="ai" element={<AI />} />
      <Route path="driver/login" element={<DriverLogin />} />
      <Route path="driver/dashboard" element={<DriverDashboard />} />
      <Route path="driver/order/:id" element={<DriverOrderDetail />} />
      <Route path="delivery/feedback/:token" element={<DeliveryFeedback />} />

      {/* Catch all unmatched routes and redirect to home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </BrowserRouter>;
}

export default App;
